var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { treatSpaceOrEnterAsClick } from '~/helpers/events';
import './tab-group.scss';
function Tab({ label, selectedLabel, setSelectedLabel, TabTag, analytics }) {
    const blurAndSetLabel = React.useCallback((event) => {
        event.currentTarget.blur();
        setSelectedLabel(label);
    }, [setSelectedLabel, label]);
    const isSelected = React.useMemo(() => label === selectedLabel, [label, selectedLabel]);
    return (React.createElement(TabTag, { role: "tab", id: ariaTabId(label), "aria-controls": ariaPanelId(label), tabIndex: 0, "aria-selected": isSelected, onClick: blurAndSetLabel, onKeyDown: treatSpaceOrEnterAsClick, "data-analytics-link": analytics && !isSelected ? '' : undefined }, label));
}
export function ariaTabId(label) {
    return `${label}-tab`;
}
export function ariaPanelId(label) {
    return `${label}-panel`;
}
export default function TabGroup(_a) {
    var _b;
    var { labels, selectedLabel, setSelectedLabel, TabTag = 'div', children } = _a, props = __rest(_a, ["labels", "selectedLabel", "setSelectedLabel", "TabTag", "children"]);
    const analyticsNav = props['data-analytics-nav'];
    const listLabel = (_b = props.listLabel) !== null && _b !== void 0 ? _b : 'Tabs';
    return (React.createElement("div", { className: "tab-heading" },
        React.createElement("div", { className: "tabs-and-extras" },
            React.createElement("div", { role: "tablist", "aria-label": listLabel, "data-analytics-nav": analyticsNav }, labels.map((label) => React.createElement(Tab, { key: label, analytics: !!analyticsNav, label, selectedLabel, setSelectedLabel, TabTag }))),
            children),
        React.createElement("hr", { className: "tab-baseline" })));
}
